module.exports = __webpack_public_path__ + "star-blueprint-hazelnut-ice-cream.3ecd2b63a736bc2833c3.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/star-blueprint-hazelnut-ice-cream.svg
// module id = ../../../../../src/assets/img/star-blueprint-hazelnut-ice-cream.svg
// module chunks = main